// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3mIQL","inner":"Footer_inner__VrCFG"};